const system = {
    namespaced: true,
    state: {
        rtGenerateStatus: null,
        travellerBuildTime: null,
        timetableImportList: []
    },
    mutations: {
      setRtGenerateStatus(state, newObj) {
        state.rtGenerateStatus = newObj;
      },
      setTravellerBuildTime(state, newTime) {
        state.travellerBuildTime = newTime;
      },
      setTimetableImportList(state, newList) {
        state.timetableImportList = newList;
      },
    },
    actions: {
        getRtGenerateStatus(context) {
            return new Promise((resolve, reject) => {
            this._vm.$traveller_http.get('/traveller/restui/maintenance/rtGenerateStatus')
                .then(response => {
                    context.commit('setRtGenerateStatus', response.data);
                    resolve(response.data);
                    return;
                }),
                error => {
                reject(error);
                }
            });
        },
        startRtGeneration() {
            return new Promise((resolve, reject) => {
              this._vm.$traveller_http.post('/traveller/restui/maintenance/startRtGeneration')
                .then(response => {
                    resolve(response);
                }),
                error => {
                  reject(error);
                }
            });
          },
        startGtfsExport() {
            return new Promise((resolve, reject) => {
              this._vm.$traveller_http.post('/traveller/restui/maintenance/startGtfsExport')
                .then(response => {
                    resolve(response);
                }),
                error => {
                  reject(error);
                }
            });
          },
        sendDrivingCycles() {
            return new Promise((resolve, reject) => {
              this._vm.$traveller_http.post('/traveller/restui/maintenance/sendDrivingCycles')
                .then(response => {
                    resolve(response);
                }),
                error => {
                  reject(error);
                }
            });
          },
        updateBlockSequences() {
            return new Promise((resolve, reject) => {
              this._vm.$traveller_http.post('/traveller/restui/maintenance/updateBlockSequences')
                .then(response => {
                    resolve(response);
                }),
                error => {
                  reject(error);
                }
            });
          },
        startTimetableCopyToRT() {
            return new Promise((resolve, reject) => {
              this._vm.$traveller_http.post('/traveller/restui/maintenance/startTimetableCopyToRT')
                .then(response => {
                    resolve(response);
                }),
                error => {
                  reject(error);
                }
            });
          },        
          getTravellerBuildTime(context) {
            return new Promise((resolve, reject) => {
            this._vm.$traveller_http.get('/traveller/restui/maintenance/travellerBuildTime')
                .then(response => {
                    context.commit('setTravellerBuildTime', response.data);
                    resolve(response.data);
                    return;
                }),
                error => {
                reject(error);
                }
            });
        },
        getTimetableImportList(context) {
          return new Promise((resolve, reject) => {
          this._vm.$traveller_http.get('/traveller/restui/maintenance/getTimetableImportList')
              .then(response => {
                  context.commit('setTimetableImportList', response.data);
                  resolve(response.data);
                  return;
              }),
              error => {
              reject(error);
              }
          });
      },
      runTimetableImport(context, params) {
        return new Promise((resolve, reject) => {
          this._vm.$traveller_http.post('/traveller/restui/maintenance/runTimetableImport', null, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            params: {importName : params.importName}
          })
            .then(response => {
                resolve(response);
                return;
            }),
            error => {
              reject(error);
            }
        });  
      },
        updateStopLocationsOnRouteShapes() {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/maintenance/updateStopLocationsOnRouteShapes')
                    .then(response => {
                        if (response.status == 200) {
                            resolve(response);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        }
    }
  }
  
  export default system;